/**
 * The message to show when an email change is rejected. `api.changeEmail`
 * throws a plain Error whose message already carries the server's reason
 * ("Error 403, Forbidden: ..."), so `err.message` is a string there. The
 * earlier `err.message?.clientMessage` read a property off that string and
 * produced an empty dialog (OWA-834). Fall back to a sentence rather than
 * nothing when no reason is available at all.
 *
 * Kept in its own module, with no imports, so it can be unit tested without
 * loading the Auth module graph (socket, IndexedDB, session replay).
 */
export function changeEmailErrorMessage(err: any): string {
    const raw =
        (typeof err?.message === 'string' && err.message) ||
        (typeof err?.message?.clientMessage === 'string' && err.message.clientMessage) ||
        (typeof err?.clientMessage === 'string' && err.clientMessage) ||
        (typeof err === 'string' && err) ||
        '';
    return raw.trim() || 'The server did not say why. Please try again, and contact Support if it keeps happening.';
}
